// extracted by mini-css-extract-plugin
export var attribution = "_bj-4";
export var authorName = "_bj-5";
export var quote = "_bj-3";
export var testimonial = "_bj-2";
export var trustedBy = "_bj-0";
export var trustedByLabel = "_bj-1";